export default function TextLoading() {
  return (
    <div className="text-loading">
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </div>
  );
}
